@if(loader){
<app-loader></app-loader>
}

<p-card [header]="(isEdit===true)?'Invoice':'Create Invoice' ">
    <div class="field col-12 flex justify-content-between align-items-center">
        <div class="flex">
            <ng-container *ngIf="!createOrderForm.controls['IsClosed'].value">
                <div>
                    @if(isEdit){
                    <p-button label="Update" severity="info" (click)="update()" icon="pi pi-arrow-circle-up"
                        size="small"></p-button>
                    <p-button label="Create Invoice" class="p-button-outlined ml-2" icon="pi pi-plus-circle"
                        size="small" (click)="createInvoice()">
                    </p-button>
                    }@else {
                    <p-button label="Save" pTooltip="Create Invoice" icon="pi pi-save" size="small"
                        (click)="validateSalesOrder('DRAFT.INVOICE')"></p-button>

                    <p-button label="Reset" (click)="resetForm()" class="p-button-outlined ml-2 " icon="pi pi-replay"
                        severity="info" size="small"></p-button>
                    }
                </div>
            </ng-container>

            <p-button *ngIf="canShow" label="Apply Credits" icon="pi pi-credit-card" size="small"
                (click)="openApplyCreditsDialog()" class="p-button-outlined ml-2">
            </p-button>

            <div>
                <p-button label="Linked Files" icon="pi pi-paperclip" size="small" (click)="openLinkedFiles()"
                    class="p-button-sm ml-2"></p-button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="Cancel()"
                    class="p-button-sm ml-2"></p-button>
            </div>
        </div>

        <div>
            <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>

    </div>

    <form [formGroup]="createOrderForm">

        <!-- </div> -->

        <div class="grid mt-3">


            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Invoice No</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText formControlName="OrderNo" placeholder="e.g 89098" type="text"
                            (blur)="checkOrderNumber()"
                            [readonly]="isEdit || !this.createOrderForm.controls.manualEntry.value || products.length > 0"
                            class="w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.OrderNo.errors }"
                            (keydown.enter)="focusNextInput($event)" />
                        @if (!isEdit) { <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" *ngIf="products.length == 0"
                                (onChange)="manualEntry()" [binary]="true" label="Manual Entry"
                                value="true"></p-checkbox>
                        </div>
                        }
                    </div>
                </div>

                <!-- <div class="field text-left">
                    <label class="label-required display">Supply Type</label>

                    <p-dropdown formControlName="supplyType" [options]="supplyTypes" optionLabel="description"
                        optionValue="code" placeholder="Select Supply Type" styleClass="w-full"
                        filterBy="code,description" [readonly]="isOpenStatus"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}">

                        <ng-template let-item pTemplate="item">
                            <span>{{item.code}} - {{item.description}}</span>
                        </ng-template>

                    </p-dropdown>
                </div> -->


                <!-- <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}}</label>
                    <p-autoComplete #productCodeInputRef formControlName="productCode" placeholder="Product Code"
                        [style]="{'height':'45px'}" (onSelect)="setProduct($event)" [suggestions]="filterProductList"
                        (completeMethod)="autosearchProduct($event)" field="productCode"
                        (keydown.enter)="focusNextInput($event)">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.productCode}} - {{item.productName}}</span>
                        </ng-template>
                    </p-autoComplete>
                </div> -->

                <div class="field text-left">
                    <label for="website" class="label-required display">{{unitLabel}}</label>
                    <p-autoComplete formControlName="warehouse" [dropdown]="(products.length > 0)? false : true"
                        [readonly]="products.length > 0" (onSelect)="setWarehouse($event)" [forceSelection]="true"
                        [suggestions]="filterWarehouses" (completeMethod)="filterWarehouse($event)"
                        field="warehouseName" placeholder="Search {{unitLabel}}" styleClass="w-full"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.warehouse.errors }"
                        (keydown.enter)="focusNextInput($event)">
                        <ng-template let-item pTemplate="item">
                            <span>{{item.warehouseCode}} - {{item.warehouseName}}</span>
                        </ng-template>
                    </p-autoComplete>
                </div>

                <div class="field text-left">
                    <label for="supplyType" class="label-required display">Supply Type</label>
                    <input pInputText readonly formControlName="supplyType" class="w-full"
                        (keydown)="onKeydown($event,products)"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.supplyType.errors}" />
                </div>
                <!-- <div class="field text-left">

                    <div *ngIf="createOrderForm.value.supplyType === 'EXPORT' || createOrderForm.value.supplyType === 'SEZ'"
                        class="field">

                        <p-checkbox formControlName="isLUT" [binary]="true" [label]="getLUTLabel()">
                        </p-checkbox>

                    </div>

                </div>
                     <div>
                    <div class="field text-left">
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)">
                        </p-checkbox>
                    </div>

                </div> -->

                <div class="field text-left flex align-items-center gap-3">

                    <div
                        *ngIf="createOrderForm.value.supplyType === 'EXPORT' || createOrderForm.value.supplyType === 'SEZ'">
                        <!-- <p-checkbox formControlName="isLUT" [binary]="true" [label]="getLUTLabel()">
                        </p-checkbox> -->
                        <p-checkbox formControlName="isLUT" [binary]="true" label="Supply under LUT (No GST)"
                            [readonly]="isOpenStatus">
                        </p-checkbox>
                    </div>

                    <!-- <div>
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)"
                            [disabled]="isRCMDisabled()">
                        </p-checkbox>

                    </div> -->
                    <div *ngIf="showRCM">
                        <p-checkbox formControlName="isRCM" [binary]="true" label="Reverse Charge (RCM)"
                            [readonly]="isOpenStatus">
                        </p-checkbox>
                    </div>

                </div>

                <div class="field text-left">
                    <div *ngIf="isExportOrSEZ()" class="field">

                        <label>Export Type</label>
                        <div class="p-2 border-round surface-100">
                            {{ getExportTypeLabel() }}
                        </div>

                    </div>

                </div>

                <div class="field text-left">
                    <label for="SalespersonCode" class="label-required display">Salesperson</label>
                    <div class="p-inputgroup p-lookup">
                        <input pInputText formControlName="salesperson" (click)="showSalesperson()" readonly
                            class="w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.salesperson.errors }"
                            (keydown)="onKeydown($event,products)" />
                        <button type="button" [disabled]="products.length > 0" pButton pRipple
                            (click)="showSalesperson()" icon="pi pi-search" styleClass="p-button-warn"></button>
                    </div>
                </div>



            </div>

            <div class="col">

                <div class="field text-left">
                    <!-- <div class="field text-left"> -->
                    <label for="BillToCustomerCode" class="label-required display">
                        Bill To Customer
                    </label>

                    <!-- <span *ngIf="outstandingReceivables !== 0" class="outstanding-indicator">
                            Outstanding Receivables : {{ outstandingReceivables | currency:'INR':'symbol':'1.2-2':'en-IN' }}
                        </span> -->
                    <!-- </div> -->
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="BillToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setBillTo($event)" [suggestions]="BillTocustomerList"
                                [forceSelection]="true" (completeMethod)="autosearchBilltoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.BillToCustomerCode.errors }"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" pButton [disabled]="products.length > 0" pRipple
                                (click)="showBillToCustomerDialog()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(true)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="BillToCustomer">Bill To Customer Name</label>
                    <input pInputText readonly formControlName="BillToCustomer" class="w-full"
                        (keydown)="onKeydown($event,products)" />
                </div>

                <div class="field text-left">
                    <label for="BillToCustomerAddress">Address</label>
                    <input pInputText formControlName="BillToCustomerAddress" class="w-full"
                        (keydown)="onKeydown($event,products)" readonly />
                </div>

                <div class="field text-left">
                    <label for="orderDate" class="label-required display">Order Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="orderDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.orderDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                    <!-- <small *ngIf="submitted && formControls.orderDate.errors" id="name-error"
                              class="text-red-500">Required field.</small> -->
                </div>

                <div class="field text-left">
                    <label for="requestedDate" class="label-required display">Requested Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" formControlName="requestedDate"
                            [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.requestedDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                    <!-- <small *ngIf="submitted && formControls.requestedDate.errors" id="name-error"
                              class="text-red-500">Required field.</small> -->
                </div>

            </div>

            <div class="col">

                <div class="field text-left">
                    <label for="ShipToCustomerCode" class="label-required display">Ship To Customer</label>
                    <span class="p-fluid">
                        <div style="display: flex;">
                            <p-autoComplete formControlName="ShipToCustomerCode" [readonly]="products.length > 0"
                                (onSelect)="setShipTo($event)" [suggestions]="ShipTocustomerList"
                                [forceSelection]="true" (completeMethod)="autosearchShiptoCustomer($event)"
                                field="customerCode" styleClass="w-full"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.ShipToCustomerCode.errors }"
                                (keydown.enter)="focusNextInput($event)">
                                <ng-template let-item pTemplate="item">
                                    <span>{{item.customerCode}} - {{item.customerName}}</span>
                                </ng-template>
                            </p-autoComplete>
                            <button type="button" [disabled]="products.length > 0" pButton pRipple
                                (click)="openShipToCustomerLookup()" icon="pi pi-search" styleClass="p-button-warn"
                                style="margin-left: 10px;"></button>
                            <p-button (click)="createQuickCustomer(false)" [disabled]="products.length > 0"
                                class="p-button-outlined ml-2 " icon="pi pi-user-plus" severity="info"></p-button>
                        </div>
                    </span>
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomer">Ship To Customer Name</label>
                    <input pInputText formControlName="ShipToCustomer" readonly class="w-full"
                        (keydown)="onKeydown($event,products)" />
                </div>

                <div class="field text-left">
                    <label for="ShipToCustomerAddress">Address</label>
                    <input pInputText formControlName="ShipToCustomerAddress" class="w-full"
                        (keydown)="onKeydown($event,products)" readonly />
                </div>

                <!-- <div class="field text-left">
                    <label>Place of Supply (POS)</label>
                    <input pInputText formControlName="POS" readonly class="w-full" />
                </div> -->

                <div class="field text-left">
                    <label>Place of Supply (POS)</label>
                    <input pInputText formControlName="POSDisplay" readonly class="w-full" />
                </div>

                <div class="field text-left" *ngIf="createOrderForm.controls.serviceCallCode.value">
                    <label for="serviceCallCode">Service Call Code</label>
                    <input pInputText formControlName="serviceCallCode" readonly class="w-full"
                        (keydown)="onKeydown($event, products)" />
                </div>

                <!-- <div class="field text-left" *ngIf="createOrderForm.controls.SalesOrderInvoiceDate.value"> -->
                <div class="field text-left" *ngIf="createOrderForm.controls['IsClosed'].value">
                    <label for="SalesOrderInvoiceDate">Invoice Date</label>
                    <div class="p-inputgroup p-lookup">
                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                            formControlName="SalesOrderInvoiceDate" [showIcon]="true" placeholder="Select Date"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.SalesOrderInvoiceDate.errors }"
                            styleClass="w-full" (keydown.enter)="focusNextInput($event)"></p-calendar>
                    </div>
                </div>

            </div>

        </div>

        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header="Order Lines">
                <!-- @if(!isEdit){ -->
                <div class="field text-left order-line-toolbar" #productCodeAutoComplete
                    *ngIf="!createOrderForm.controls['IsClosed'].value"
                    style="display: flex; align-items: center; gap: 10px; margin-bottom: 0.5rem; flex-wrap: nowrap;">

                    <!-- New Product link -->
                    <span style="margin-left: -16px; display: inline-block;">
                        <p-button icon="pi pi-plus" (onClick)="createQuickProduct()" [link]="true" label="New Product"
                            [size]="'small'" styleClass="white-space-nowrap"></p-button>
                    </span>

                    <!-- Product Image -->
                    <p-image [src]="previewImage" alt="product" width="40" [preview]="true"></p-image>

                    <!-- Product Code -->
                    <!-- <div style="flex: 0 0 160px; min-width: 120px; max-width: 160px;">
                        <p-autoComplete #productCodeInputRef formControlName="searchproductCode"
                            placeholder="Search Product Code" styleClass="w-full" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}" (onSelect)="setProduct($event)"
                            [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                            field="customerCode" (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item" class="text-left">
                                <span>{{item.productCode}} - {{item.productName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div> -->
                    <!-- <div style="flex: 0 0 160px; min-width: 120px; max-width: 160px;">
                        <p-autoComplete #productCodeInputRef formControlName="searchproductCode"
                            placeholder="Search Product Code" styleClass="w-full" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}" (onSelect)="setProduct($event)"
                            [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                            field="customerCode" (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item" class="text-left">
                                <span>{{item.productCode}} - {{item.productName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div> -->

                    <div style="flex: 0 0 250px; margin-left: 10px;">
                        <p-autoComplete #productCodeInputRef formControlName="productCode" placeholder="Product Code"
                            [style]="{'height':'45px'}" (onSelect)="setProduct($event)"
                            [suggestions]="filterProductList" (completeMethod)="autosearchProduct($event)"
                            field="productCode" (keydown.enter)="focusNextInput($event)">
                            <ng-template let-item pTemplate="item" class="text-left">
                                <span>{{item.productCode}} - {{item.productName}}</span>
                            </ng-template>
                        </p-autoComplete>
                    </div>

                    <!-- QAvail Label and Value -->
                    <div style="text-align: center; flex-shrink: 0; white-space: nowrap; min-width: 80px;">
                        <p style="margin: 0; font-weight: bold; font-size: 13px;">Q-Avail</p>
                        <p style="margin: 0; font-size: 13px;">{{QAvail}}</p>
                    </div>

                    <!-- Product Name -->
                    <div style="flex: 1 1 0; min-width: 160px; max-width: 100%; overflow: hidden;">
                        <input pInputText formControlName="productDescription" readonly placeholder="Product Name"
                            class="w-full" style="width: 100%; box-sizing: border-box;"
                            (keydown)="onKeydown($event,products)" />
                    </div>

                    <!-- Qty -->
                    <div style="flex: 0 0 140px; min-width: 120px; max-width: 140px;">
                        <input pInputText id="Qty" type="number" [formControlName]="getFormControlName()"
                            placeholder="Qty" min="0" class="w-full" (keydown.enter)="focusNextInput($event)" />
                    </div>

                    <!-- Add button -->
                    <!-- <p-button label="Add" (onClick)="addProduct()"
                        [disabled]="!createOrderForm.controls.productCode.value ||
                                            !createOrderForm.controls.productDescription.value ||
                                            !(productCostCalculationType === 'qty' ? createOrderForm.controls.productQty.value : createOrderForm.controls.productWgt.value)"
                        [raised]="true" [size]="'small'" severity="info"></p-button> -->

                    <p-button label="Add" (onClick)="addProduct()"
                        [disabled]="!createOrderForm.controls.productCode.value ||
                                            !createOrderForm.controls.productDescription.value ||
                                            !(productCostCalculationType === 'qty' ? createOrderForm.controls.productQty.value : createOrderForm.controls.productWgt.value)"
                        [raised]="true" [size]="'small'" severity="info"></p-button>

                    <!-- Delete button -->
                    <p-button icon="pi pi-trash" (onClick)="deleteProduct()" [disabled]="selectedProduct.length === 0"
                        [raised]="true" [size]="'small'" severity="danger"></p-button>

                </div>

                <!-- } -->


                <p-table #dt1 [value]="products" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [rowHover]="true" [paginator]="true" [rows]="10"
                    [rowsPerPageOptions]="[10, 15, 20]" [paginator]="true" [(selection)]="selectedProduct">
                    <!-- (onEditComplete)="onProductEdit($event)"> -->
                    <ng-template pTemplate="header">
                        <tr>
                            <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                            <th>Sr No</th>
                            <th pSortableColumn="ProductCode">Code <p-sortIcon field="ProductCode"></p-sortIcon></th>
                            <th>Product Name </th>
                            <th>UOM </th>
                            <th></th>
                            <th>HSN/SAC</th>
                            <th>Qty</th>
                            <th class="text-right">Price(₹)</th>
                            <th class="text-right">Amount(₹)</th>
                            <th class="text-right">Discount(%)</th>
                            <th class="text-right">Net Amount(₹)</th>
                            <th class="text-right">GST(%)</th>
                            <!-- <th>Weight</th> -->
                            <th class="text-right">GST(₹)</th>
                            <th class="text-right">Line Amount(₹)</th>
                            <!-- <th>Remark</th> -->
                            <th>Delivery Date</th>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product let-i="rowIndex">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td>
                            <td>{{i+1}}</td>

                            <td [pEditableColumn]="product" pEditableColumnField="ProductCode"
                                class="text-blue-500 underline" style="cursor: pointer;"
                                (click)="openProductView(product)">
                                {{ product.ProductCode }}
                            </td>
                            <td>{{ product.ProductDescription }}</td>
                            <!-- <td [pEditableColumn]="product" pEditableColumnField="ProductDescription">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input pInputText type="text" (blur)="onProductEdit(product)"
                                                [(ngModel)]="product.ProductDescription"
                                                [ngModelOptions]="{ standalone: true }"
                                                (keydown)="onKeydown($event,product)" />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <span *ngIf="product.ProductDescription.length > 20; else fullText">
                                                {{ product.ProductDescription }}
                                            </span>
                                            <ng-template #fullText>
                                                {{ product.ProductDescription }}
                                            </ng-template>
                                        </ng-template>
                                    </p-cellEditor>
                                </td> -->

                            <td [pEditableColumn]="product" [pEditableColumnField]="'uom'">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div class="p-inputgroup p-lookup">
                                            <input type="text" pInputText class="p-inputtext" [(ngModel)]="product.Uom"
                                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                                [ngModelOptions]="{ standalone: true }" [disabled]="true" />
                                            <button type="button" pButton pRipple icon="pi pi-search"
                                                styleClass="p-button-warn" (click)="showProductUom(product)"
                                                [disabled]="createOrderForm.get('IsClosed')?.value"></button>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ product.Uom }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td><span class="text-lg cursor-pointer" (click)="showSpecification(product)"><i
                                        class="pi pi-flag-fill"></i></span></td>

                            <td>{{product.HSNCode}}</td>

                            <td (click)="toggleEdit(product, 'OrderQuantity')" [pEditableColumn]="product"
                                pEditableColumnField="QuotedQuantity">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" min="0" class="p-inputtext-sm"
                                            [(ngModel)]="product.OrderQuantity"
                                            [readonly]="createOrderForm.get('IsClosed')?.value"
                                            [ngModelOptions]="{ standalone: true }" (blur)="onProductEdit(product)"
                                            (keydown)="onKeydown($event,product)" *ngIf="isEditingQuantity" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ product.OrderQuantity }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td class="text-right" [pEditableColumn]="product" pEditableColumnField="UnitPrice">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="1"
                                            [(ngModel)]="product.UnitPrice"
                                            [readonly]="createOrderForm.get('IsClosed')?.value"
                                            [ngModelOptions]="{ standalone: true }" (blur)="onProductEdit(product)"
                                            (keydown)="onKeydown($event,product)" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        &nbsp;{{ product.UnitPrice.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2}) }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td class="text-right">{{product.ExtensionPrice.toLocaleString('en-IN', {
                                minimumFractionDigits: 2, maximumFractionDigits: 2})}} </td>

                            <td class="text-right" [pEditableColumn]="product" pEditableColumnField="Discount">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="number" class="p-inputtext-sm" min="0" max="100"
                                            [(ngModel)]="product.Discount" (keydown)="onKeydown($event, product)"
                                            (blur)="onProductEdit(product)" [ngModelOptions]="{ standalone: true }"
                                            [disabled]="isLineDiscountDisabled()"
                                            [readonly]="createOrderForm.get('IsClosed')?.value" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{product.Discount?.toLocaleString('en-IN', { minimumFractionDigits: 2,
                                        maximumFractionDigits: 2})}}%
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="text-right">{{product.NetAmount?.toLocaleString('en-IN', { minimumFractionDigits:
                                2,
                                maximumFractionDigits: 2})}}</td>
                            <td class="text-right">{{product.GSTRate}}</td>
                            <td class="text-right">{{product.SalesTax.toLocaleString('en-IN', { minimumFractionDigits:
                                2, maximumFractionDigits: 2})}}</td>
                            <td class="text-right">{{product.LineTotal?.toLocaleString('en-IN', { minimumFractionDigits:
                                2,
                                maximumFractionDigits: 2})}}</td>

                            <!-- <td class="text-center"><span class="text-lg cursor-pointer"
                                    (click)="showComment(product)"><i class="pi pi-comment"></i></span></td> -->

                            <td style="width: 130px;">
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy"
                                    (blur)="onProductEdit(product)" [(ngModel)]="product.deliveryDate"
                                    [ngModelOptions]="{ standalone: true }" [style]="{ width: '120px' }"
                                    appendTo="body">
                                </p-calendar>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="grid" style="margin-left: 5%;">
                            <div class="col-5 md:col-8">
                                <div class="grid formgrid">

                                    <div class="field col-12 md:col-3">
                                        <label>
                                            Header Discount(₹)
                                            <i class="pi pi-info-circle"
                                                pTooltip="Header discount will be applied when line discounts are not used. Line discounts are percentage-based."
                                                tooltipPosition="top" style="margin-left:5px; cursor:pointer;">
                                            </i>
                                        </label>
                                        <input type="text" pInputText class="w-full" formControlName="DiscountAmount"
                                            [readonly]="createOrderForm.get('IsClosed')?.value">
                                        <!-- <div *ngIf="createOrderForm.get('DiscountAmount')?.hasError('exceedTotal')"
     style="color: red; font-weight: normal; font-size: 14px; margin-top: 4px;">
  Discount cannot be greater than order total.
</div> -->
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Freight Charges(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="FreightTotal"
                                            [readonly]="createOrderForm.get('IsClosed')?.value">
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>Rate on Freight</label>
                                        <p-dropdown class="w-full" [options]="gstOptions" optionLabel="label"
                                            optionValue="value" placeholder="Select GST" formControlName="RateOnFreight"
                                            [readonly]="!!createOrderForm.get('IsClosed')?.value">
                                        </p-dropdown>
                                    </div>

                                    <div class="field col-12 sm:col-6 lg:col-3">
                                        <label>GST on Freight(₹)</label>
                                        <input type="text" pInputText class="w-full" formControlName="GSTOnFreight"
                                            [readonly]="createOrderForm.get('IsClosed')?.value">
                                    </div>


                                </div>
                            </div>

                            <div class="col-12 md:col-4 flex flex-column align-items-end">

                                <div class="field">
                                    CGST : ₹
                                    {{CGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    SGST : ₹
                                    {{SGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    IGST : ₹
                                    {{IGSTtotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>

                                <div class="field">
                                    Taxable : ₹
                                    {{Taxable.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="field">
                                    Final Taxable Amount : ₹
                                    {{FinalTaxableAmt.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                </div>
                                <div class="hr-line w-full my-2"></div>

                                <div class="flex align-items-center">
                                    <div class="mr-2">
                                        Total Qty :
                                        <span>{{weightTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}
                                        </span>
                                    </div>
                                    <div class="mx-2">|</div>
                                    <div>
                                        Total : ₹
                                        <span>{{orderTotal.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})}}</span>
                                    </div>
                                </div>

                                <div *ngIf="priorPaidAmount > 0" class="field mt-2">
                                    Prior Paid : ₹
                                    <span>{{
                                        priorPaidAmount.toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})
                                        }}</span>
                                </div>

                            </div>

                        </div>
                    </ng-template>
                </p-table>

            </p-tabPanel>

            <p-tabPanel header="Invoice Details">
                <div class="grid">

                    <div class="col">
                        <div class="field text-left">
                            <label>Motor Vehical No.</label>
                            <input type="text" formControlName="MotorVehicalNo" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label>Dispatch Doc No.</label>
                            <input type="text" formControlName="DispatchDocNo" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label>Dispatch Through</label>
                            <input type="text" formControlName="DispatchThrough" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label for="ReferenceNumber">Reference Number</label>
                            <input type="text" formControlName="ReferenceNumber" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>

                        <div class="field text-left">
                            <label for="Destination">Destination</label>
                            <input type="text" formControlName="Destination" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown.enter)="focusNextInput($event)" />
                        </div>
                    </div>

                    <div class="col">
                        <div class="field text-left">
                            <label>Shipment Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="ShipmentDate" styleClass="w-full"
                                [showIcon]="true" [touchUI]="false" [showIcon]="true">
                            </p-calendar>
                        </div>

                        <div class="field text-left">
                            <label>Bill Of Lading / LR-RR No.</label>
                            <input type="text" formControlName="BillOfLading" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label>EWB No</label>
                            <input type="text" formControlName="EwbNo" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label>Customer PO Number</label>
                            <input type="text" formControlName="purchaseOrderNumber" pInputText class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"
                                (keydown)="onKeydown($event, products)" />
                        </div>

                        <div class="field text-left">
                            <label>Customer PO Date</label>
                            <p-calendar [iconDisplay]="'input'" formControlName="CustomerPODate" dateFormat="dd/mm/yy"
                                styleClass="w-full" [showIcon]="true"
                                (keydown.enter)="focusNextInput($event)"></p-calendar>
                        </div>


                    </div>

                    <div class="col">
                        <div class="field text-left">
                            <label for="TermsCode">Payment Terms</label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText formControlName="TermsCode"
                                    [readonly]="createOrderForm.get('IsClosed')?.value" (click)="showTermsCode()"
                                    class="w-full" />
                                <button type="button" pButton pRipple (click)="showTermsCode()" icon="pi pi-search"
                                    styleClass="p-button-warn"></button>
                            </div>
                        </div>

                        <div class="field text-left">
                            <label for="deliveryNote">Delivery Note</label>
                            <textarea rows="3" pInputTextarea formControlName="deliveryNote" class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"></textarea>
                        </div>

                        <div class="field text-left">
                            <label for="TermsOfDelivery">Terms Of Delivery</label>
                            <textarea rows="3" pInputTextarea formControlName="TermsOfDelivery" class="w-full"
                                [readonly]="createOrderForm.get('IsClosed')?.value"></textarea>
                        </div>

                        <div class="field text-left">
                            <label for="projectName">Project Name</label>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <input pInputText formControlName="projectName" readonly placeholder="Select Project" style="width: 200px;" />
                                <p-button icon="pi pi-search" (click)="getProjectLookup()" [raised]="true" [size]="'small'" severity="info"
                                    [disabled]="canEdit"></p-button>
                                <button *ngIf="createOrderForm.get('projectName')?.value" type="button" pButton pRipple icon="pi pi-times"
                                    class="p-button-danger" severity="danger" (click)="clearProject()" title="Clear Project"
                                    [disabled]="canEdit"></button>
                            </div>
                        </div>
                    </div>

                </div>
            </p-tabPanel>

            <p-tabPanel header="GL Posting Details" *ngIf="showGlPostingTab">
                <div class="gl-posting-section gl-posting-in-tab mt-3">
                    <p-table *ngIf="glEntries.length > 0" [value]="glEntries" [tableStyle]="{'min-width': '60rem'}"
                        [tableStyle]="{'min-width': '60rem'}" styleClass="p-datatable-sm p-datatable-gridlines">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let col of glDisplayColumns" [class.text-right]="col.align === 'right'">{{
                                    col.header }}</th>

                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td *ngFor="let col of glDisplayColumns" [class.text-right]="col.align === 'right'">
                                    <ng-container [ngSwitch]="col.format">
                                        <span *ngSwitchCase="'amount'">{{ formatGlAmount(row[col.field]) }}</span>
                                        <span *ngSwitchCase="'date'">{{ row[col.field] | date:'dd/MM/yyyy' }}</span>
                                        <span *ngSwitchDefault>{{ row[col.field] }}</span>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td [attr.colspan]="glFooterLabelColspan()" class="text-right font-bold">Total</td>
                                <td class="text-right font-bold">{{ formatGlAmount(glTotalDebit) }}</td>
                                <td class="text-right font-bold">{{ formatGlAmount(glTotalCredit) }}</td>
                                <td [attr.colspan]="glFooterTrailingColspan()"></td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p *ngIf="glEntries.length === 0" class="text-color-secondary m-0">
                        GL entries will appear here after the invoice is created and posted.
                    </p>
                </div>
            </p-tabPanel>

        </p-tabView>


    </form>

</p-card>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<p-dialog header="Credit Limit Exceeded" [(visible)]="creditLimitExceeded" [modal]="true" [closable]="false"
    styleClass="w-40rem" [style]="{minWidth: '400px'}">
    <div class="p-mb-4">
        <h3 class="text-danger" style="margin-bottom: 0;">
            Credit limit has exceeded by <strong>{{ exceededAmount | currency:'INR':'symbol-narrow' }}</strong>
        </h3>
        <p class="mt-1">You cannot create this invoice as the customer's credit limit has exceeded the set value.</p>
    </div>

    <button type="button" class="p-link p-mb-3" (click)="toggleDetails($event)"
        style="padding:0; border:none; background:none; cursor:pointer; color: blue; text-decoration: underline;">
        {{ showCreditDetails ? 'Hide Details' : 'View Details' }}
        <i class="pi" [ngClass]="{'pi-angle-up': showCreditDetails, 'pi-angle-down': !showCreditDetails}"
            style="margin-left: 0.5rem;"></i>
    </button>

    <div *ngIf="showCreditDetails" class="p-mt-3"
        style="max-height: 200px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px; padding: 1rem; background: #f9f9f9;">
        <table class="p-datatable-table" style="width: 100%; font-size: 0.95rem;">
            <tbody>
                <tr>
                    <td>Outstanding Receivables</td>
                    <td class="text-right font-weight-bold">{{ totalOutstanding | currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td>Invoice Amount</td>
                    <td class="text-right font-weight-bold">{{ invoiceAmount | currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <hr class="p-mb-2 p-mt-2" />
                    </td>
                </tr>
                <tr>
                    <td><strong>Total Outstanding Receivables</strong></td>
                    <td class="text-right font-weight-bold">{{ (totalOutstanding + orderTotal) |
                        currency:'INR':'symbol-narrow' }}</td>
                </tr>
                <tr>
                    <td>Customer Credit Limit</td>
                    <td class="text-right font-weight-bold">{{ customerCreditLimit | currency:'INR':'symbol-narrow' }}
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <hr class="p-mb-2 p-mt-2" />
                    </td>
                </tr>
                <tr>
                    <td><strong class="text-danger">Exceeded Amount</strong></td>
                    <td class="text-right text-danger font-weight-bold">{{ exceededAmount |
                        currency:'INR':'symbol-narrow' }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <ng-template pTemplate="footer">
        <button *ngIf="!showCreditDetails" pButton label="OK" icon="pi pi-check" (click)="closeCreditDialog()"
            class="p-button-primary"></button>
        <ng-container *ngIf="showCreditDetails">
            <button pButton label="Proceed" icon="pi pi-check" (click)="continueInvoiceCreation()"
                class="p-button-success"></button>
            <button pButton label="Cancel" icon="pi pi-times" (click)="closeCreditDialog()"
                class="p-button-primary"></button>
        </ng-container>
    </ng-template>
</p-dialog>